import { api, useCurrentUser } from '@cma/app'
import {
  UpdatePlatformClientContentMutation,
  UpdatePlatformClientContentMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useUpdatePlatformClientContents() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    UpdatePlatformClientContentMutation,
    Error,
    UpdatePlatformClientContentMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation UpdatePlatformClientContent(
          $ids: [ID!]!
          $folderId: ID
          $displayName: String
        ) {
          updatePlatformClientContent(
            ids: $ids
            folderId: $folderId
            displayName: $displayName
          ) {
            errors
            updatedIds
            platformClientContents {
              accountId
              createdAt
              displayName
              folderId
              id
              platformClientContentContentType
              platformClientContentUrl
              thumbnail
              updatedAt
            }
          }
        }
      `
      return api<
        UpdatePlatformClientContentMutation,
        UpdatePlatformClientContentMutationVariables
      >({ query, variables })
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: currentUser?.account?.id || '' }
        ])
      }
    }
  )
}
